/**
 * 引入全局指令
 */
export default Vue => {
  /* eslint-disable*/
  ;(requireContext => {
    //pretty-quick自动给IFEE添加分号eslint报错
    const arr = requireContext.keys().map(requireContext) || []
    arr.forEach(directive => {
      //支持commonjs或es6模块
      directive =
        directive.__esModule && directive.default
          ? directive.default
          : directive
      Object.keys(directive).forEach(key => {
        // console.log(`---------注册${key}全局指令---------`)
        Vue.directive(key, directive[key])
      })
    })
  })(require.context('../directives', false, /^\.\/.*\.js$/))
}



// WEBPACK FOOTER //
// ./src/units/directivesPlugin.js